import {
  Arbeitsbereich,
  Mitarbeiter,
} from '@/domain/navigation/benachrichtigungen/types/Benachrichtungen';
import dayjs from 'dayjs';

export class SchichttauschAntrag {
  constructor({
    id,
    mitarbeiter,
    schicht,
    bemerkungAntragsteller,
    erstellungsDatum,
  }: {
    id: string;
    mitarbeiter: Mitarbeiter;
    schicht: Schicht;
    bemerkungAntragsteller: string;
    erstellungsDatum: string;
  }) {
    this.id = id;
    this.mitarbeiter = mitarbeiter;
    this.schicht = schicht;
    this.bemerkungAntragsteller = bemerkungAntragsteller;
    this.erstellungsDatum = erstellungsDatum;
  }

  id: string;
  mitarbeiter: Mitarbeiter;
  schicht: Schicht;
  bemerkungAntragsteller: string;
  erstellungsDatum: string;
}

export class Schicht {
  constructor({
    arbeitsbereich,
    beginn,
    ende,
  }: {
    arbeitsbereich: Arbeitsbereich;
    beginn: dayjs.Dayjs;
    ende: dayjs.Dayjs;
  }) {
    this.arbeitsbereich = arbeitsbereich;
    this.beginn = beginn;
    this.ende = ende;
  }

  arbeitsbereich: Arbeitsbereich;
  beginn: dayjs.Dayjs;
  ende: dayjs.Dayjs;
}
